import { State } from 'b2b-apps/shop/common/redux/types';
import { LANGUAGE_CODE } from 'b2b-common/core/i18n/consts';
import { I18nState } from './types';

export const getState = (state: State): I18nState => state.i18n;

export const getTranslations = (
  state: State,
): Record<string, string> => getState(state).translations;

export const getActiveLanguage = (state: State): LANGUAGE_CODE => getState(state).activeLanguage;
